export default {
  sectioncode: { name: 'Type de programme', order: 1 },
  region: { name: 'Région', order: 2 },
  department: { name: 'Département', order: 3, parent: 'region', hierarchy: 2 },
  city: { name: 'Ville', order: 4, parent: 'department', hierarchy: 3 },
  organizationalentitypaths: { name: 'Filiale', order: 5 }
};
